module.exports = __webpack_public_path__ + "img/htcs.ccaf778c.jpg";